module.exports = __webpack_public_path__ + "img/xk.xk082e702.svg";